
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Portfolio from "../pages/portfolio/page";
import Contact from "../pages/contact/page";
import InvestPage from '../pages/invest/page';
import ProductsPage from '../pages/products/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
  path: "/services",
  element: <ProductsPage />,
  },
  {
    path: "/portfolio",
    element: <Portfolio />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  { path: '/invest', 
    element: <InvestPage />,
  },
  {
    path: "/products",
    element: <ProductsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
  
,
  
];

export default routes;
